import axios from "axios";

//Change This
const module = 'packing-list'

// operatore della packing list (badge): resta in sessionStorage, cosi' il dettaglio aperto
// da link o dopo un refresh sa ancora chi sta lavorando
const OPERATOR_KEY = 'packingList:operator'
function readOperator() {
    try {
        return JSON.parse(sessionStorage.getItem(OPERATOR_KEY) || '{}') || {}
    } catch (e) {
        return {}
    }
}

const state = {
    packing_lists:[],
    packing_list : [],
    index:'',
    sortBy:'',
    sortDesc:'',
    setting:{},

    operator: readOperator()
}

const getters = {
    getPackingLists: state => {
        return state.packing_lists
    },
    getPackingList: state => {
        return state.packing_list
    },
    getIndex: state => {
        return state.index;
    },
    getSortBy: state => {
        return state.sortBy;
    },
    getSortDesc: state => {
        return state.sortDesc;
    },
    getSetting: state => {
        return state.setting;
    },
    getOperator: state => {
        return state.operator
    },
}

const actions = {
    asyncFetchData : async (context,settings) => {

        context.commit('setSetting', settings);
        const {sortBy, sortDesc, page, itemsPerPage} = settings.options;

        context.commit('setSortDesc', sortDesc[0]);
        context.commit('setSortBy', sortBy[0]);
        return await axios.post(`${context.rootGetters['settings/getUrl']}${module}`,
            {
                'data': {
                    "sortBy": sortBy[0],
                    'sortDesc': sortDesc[0],
                    'page': page,
                    'itemsPerPage': itemsPerPage,
                    'filters': (settings.filters) ? settings.filters : '',
                    'search': settings.search
                }
            },
            {
                'headers': {'Authorization': `Bearer ${context.rootGetters['profile/getToken']}`},
                "Content-Type": "application/json"
            },
        ).then(res => {

                context.commit('setPackingLists', res.data.data);
                return res.data.pagination

        }).catch(err => {
                console.log("errore", err);
        });

    },
    destroyData : (context) =>{
        context.commit('setPackingLists',[]);
        context.commit('setPackingList',[]);
        context.commit('setIndex','');
    },
    index: async (context, payload) => {

        let url = `${module}/create-new`;

        return await axios.post(`${context.rootGetters['settings/getUrl']}${url}`, {
                pagination: state.table_options,
                filter: state.filter
            },
            {
                'headers': {'Authorization': `Bearer ${context.rootGetters['profile/getToken']}`},
                "Content-Type": "application/json"
            },
        ).then(result => {

            return result.data.result

        }).catch(error => {
            console.log(error.response.data)
            console.log(error.message)
        });

    },
    getOrder: async (context, payload) => {

        let url = `${module}/get-order`;

        return await axios.post(`${context.rootGetters['settings/getUrl']}${url}`, payload,
            {
                'headers': {'Authorization': `Bearer ${context.rootGetters['profile/getToken']}`},
                "Content-Type": "application/json"
            },
        ).then(result => {

            return result.data

        }).catch(error => {
            console.log(error.response.data)
            console.log(error.message)
        });

    },
    store: async (context, payload) => {

        let url = `${module}/store/`;

        return await axios.post(`${context.rootGetters['settings/getUrl']}${url}`, payload, {
                'headers': {'Authorization': `Bearer ${context.rootGetters['profile/getToken']}`}
            },
        ).then(result => {

            return {
                success: true,
                result: result.data
            }

        }).catch(error => {
            console.log(error.response.data)
            console.log(error.message)
        });

    },
    edit: async (context, payload) => {

        let url = `${module}/${payload.id}`;

        return await axios.get(`${context.rootGetters['settings/getUrl']}${url}`, {
                'headers': {'Authorization': `Bearer ${context.rootGetters['profile/getToken']}`},
                "Content-Type": "application/json"
            },
        ).then(result => {

            return result.data

        }).catch(error => {
            console.log(error.response.data)
            console.log(error.message)
        });

    },
    shipmentLabel: async (context, payload) => {

        let url = `${module}/${payload.id}/label`;

        return await axios.get(`${context.rootGetters['settings/getUrl']}${url}`, {
                'headers': {'Authorization': `Bearer ${context.rootGetters['profile/getToken']}`},
                "Content-Type": "application/json"
            },
        ).then(result => {

            return result.data

        }).catch(error => {
            console.log(error.message)
            return null
        });

    },
    update: async (context, payload) => {

        let url = `${module}/update/${payload.id}`;

        return await axios.post(`${context.rootGetters['settings/getUrl']}${url}`, payload.item, {
                'headers': {'Authorization': `Bearer ${context.rootGetters['profile/getToken']}`},
                "Content-Type": "application/json"
            },
        ).then(result => {

            return {
                success: true,
                result: result.data
            }

        }).catch(error => {
            console.log(error.response.data)
            console.log(error.message)
        });

    },
    reset: async (context, payload) => {

        let url = `${module}/reset/${payload.id}`;

        return await axios.post(`${context.rootGetters['settings/getUrl']}${url}`, payload, {
                'headers': {'Authorization': `Bearer ${context.rootGetters['profile/getToken']}`},
                "Content-Type": "application/json"
            },
        ).then(result => {

            return {
                success: true,
                result: result.data
            }

        }).catch(error => {
            console.log(error.response.data)
            console.log(error.message)
        });

    },
    cancel: async (context, payload) => {

        let url = `${module}/cancel/${payload.id}`;

        return await axios.post(`${context.rootGetters['settings/getUrl']}${url}`, payload, {
                'headers': {'Authorization': `Bearer ${context.rootGetters['profile/getToken']}`},
                "Content-Type": "application/json"
            },
        ).then(result => {

            return {
                success: true,
                result: result.data
            }

        }).catch(error => {
            console.log(error.response.data)
            console.log(error.message)
        });

    },
    delete: async (context, payload) => {

        let url = `${module}/delete/${payload.id}`;

        return await axios.post(`${context.rootGetters['settings/getUrl']}${url}`, {}, {
                'headers': {'Authorization': `Bearer ${context.rootGetters['profile/getToken']}`},
                "Content-Type": "application/json"
            },
        ).then(result => {

            return {
                success: true,
                result: result.data
            }

        }).catch(error => {
            console.log(error.response.data)
            console.log(error.message)
        });

    },
    massDelete: async (context, payload) => {

        let url = `${module}/mass-delete`;

        return await axios.post(`${context.rootGetters['settings/getUrl']}${url}`, payload, {
                'headers': {'Authorization': `Bearer ${context.rootGetters['profile/getToken']}`},
                "Content-Type": "application/json"
            },
        ).then(result => {

            return {
                success: true,
                result: result.data
            }

        }).catch(error => {
            console.log(error.response.data)
            console.log(error.message)
        });

    },



    setOperator: async (context, value) => {
        context.commit('SET_OPERATOR', value)
    },
}

const mutations = {
    setPackingLists: (state,value) => {
        state.packing_lists = value;
    },
    setPackingList: (state,value) => {
        state.packing_list = value;
    },
    setIndex: (state,value) => {
        state.index= value;
    },
    setSortBy: (state,value) => {
        state.sortBy= value;
    },
    setSortDesc: (state,value) => {
        state.sortDesc= value;
    },
    setSetting: (state,value) => {
        state.setting= value;
    },


    SET_OPERATOR: (state, value) => {
        state.operator = value || {}
        try {
            sessionStorage.setItem(OPERATOR_KEY, JSON.stringify(state.operator))
        } catch (e) {
            // niente sessionStorage: l'operatore resta solo in memoria
        }
    },
}


export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}

